/*=========================================================================================
  File Name: moduleProjectActions.js
  Description: Project Module Actions
==========================================================================================*/

import projectCardGql from "@/http/requests/agile/project_gql";

export default {
	setProjectsSearchQuery({ commit }, query) {
		commit("SET_PROJECTS_SEARCH_QUERY", query);
	},

	fetchProjectsManagement({ commit }, payload) {
		console.log("fetchProjectsManagement");
		return new Promise((resolve, reject) => {
			projectCardGql
				.fetchProjects(payload)
				.then(response => {
					commit("SET_PROJECTS", response.customers);
					commit("SET_TOTAL_PROJECTS", response.total);
					resolve(response);
				})
				.catch(error => {
					console.log(error);
					reject(error);
				});
		});
	},

	addProject({ state, commit }, customer) {
		return new Promise((resolve, reject) => {
			projectCardGql
				.addProject(customer)
				.then(response => {
					commit("ADD_PROJECT", response);
					commit("SET_TOTAL_PROJECTS", state.total + 1);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateProject({ commit }, customer) {
		return new Promise((resolve, reject) => {
			projectCardGql
				.updateProject(customer)
				.then(response => {
					commit("UPDATE_PROJECT", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteProject({ state, commit }, customerId) {
		return new Promise((resolve, reject) => {
			projectCardGql
				.deleteProject(customerId)
				.then(response => {
					commit("DELETE_PROJECT", customerId);
					commit("SET_TOTAL_PROJECTS", state.total - 1);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
